import { jsx as a } from "react/jsx-runtime";
import { SystemValidationStatus as o } from "../../enums.js";
import { ValidationBase as s } from "./ValidationBase/ValidationBase.js";
const i = (t) => /* @__PURE__ */ a(s, { ...t, as: "div" });
i.Status = o;
export {
  i as IressValidationMessage
};
